"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_READY_BUTTON_TEXT = exports.COLOR_READY_BUTTON = void 0;
exports.COLOR_READY_BUTTON = "#38b764";
exports.COLOR_READY_BUTTON_TEXT = "#000000";
